import {createContext, createElement as h} from "react";

import {Types}  from "@Common/types";
import {cache1} from "@Common/utils/cache1";

import {cs} from "./chain-services";


const ctxPairs = cache1(() => createContext(null));

export const provideContext1 = (key, value, next) => (
    h(ctxPairs(key).Provider, {value}, next(value))
);

export const provideContext = (values, next) => cs(
    ...Object.keys(values).map((key) => (
        (_, next) => h(ctxPairs(key).Provider, {value: values[key]}, next())
    )),
    next,
);

export const consumeContext:Types.Common.React.Context.ConsumeContext = <Name extends string>(name:Name): [Name, (_:any, next:any) => any] =>
    [name, (_, next) => h(ctxPairs(name).Consumer, {}, next)]
;
